import { Alert, Box } from "@mui/material";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useMemo } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import contextStore from "stores/contextStore";
import EmailThemeForm from "./EmailThemeForm";

export default function EmailThemeEditForm() {
  const { formatMessage: t } = useIntl();
  const { emailThemeUrl, notificationService } = useGlobalContext();
  const { organizationId, organizationName } = contextStore.useState();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const organizationIdMemo = useMemo(() => organizationId!, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const organizationNameMemo = useMemo(() => organizationName!, []);

  const { data, isLoading, isError } = useQuery(
    ["getEmailTheme", organizationIdMemo],
    () => notificationService.getEmailTheme()
  );

  useTitle(
    t({ id: "editEmailThemeTitle" }, { organizationName: organizationNameMemo })
  );

  if (isLoading) return <Loader />;
  if (isError) {
    return (
      <Box mt={4}>
        <Alert severity="error">
          <T id="fetchError" />
        </Alert>
      </Box>
    );
  }

  const emailTheme = data?.data;

  return (
    <>
      <RedirectBackButton
        redirectRoute={emailThemeUrl()}
        labelKey="backToDetailsButtonLabel"
      />
      <h2>
        <T id="editEmailTheme" />
      </h2>
      <EmailThemeForm
        submitLabel={t({ id: "updateEmailTheme" })}
        emailTheme={emailTheme}
        organizationId={organizationIdMemo}
      />
    </>
  );
}
